import React from "react";
import PropTypes from "prop-types";

import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Button from "../../components/Button/Button.jsx";
import SvgIcon from "../../components/Icon/SvgIcon.jsx";

import { apiBindContractToProcess } from "../../api/methods/contract.js";
import { APP_ROUTES } from "../../router";

import { SERVICES_HOME } from "../../utils/consts/service";

const ContractItem = ({ contractNumber, services, setHasError }) => {
  const history = useNavigate();
  const { mobileConnectionInfo } = useSelector(state => state);
  const { apiKey } = mobileConnectionInfo;

  /**
   * В случае когда к выбранному ЕЛС нужно добавить новый субдоговор услуги,
   * необходимо связать выбранный договор с процессом в ERP.
   *
   * @param {Number} contractNumber
   */
  const selectContract = async contractNumber => {
    try {
      await apiBindContractToProcess(apiKey, contractNumber);
      history(APP_ROUTES.MOBILE_CONNECTION.CHOICE_SERVICES_ROUTE);
    } catch {
      setHasError(true);
    }
  };

  return (
    <div className="exist-contract">
      <div className="exist-contract__info">
        <div className="exist-contract__info-top">
          <div className="exist-contract__title">{contractNumber}</div>
          <div className="exist-contract__services">
            {services.map((service, index) => (
              <div className="exist-contract__service" key={index}>
                {SERVICES_HOME[service.type] && (
                  <SvgIcon hasBg name={SERVICES_HOME[service.type].icon} color="#AAABAD" />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      <Button
        color="primary"
        size="md"
        className="exist-contract__btn"
        onClick={() => selectContract(contractNumber)}
      >
        Выбрать
      </Button>
    </div>
  );
};

ContractItem.propTypes = {
  contractNumber: PropTypes.number.isRequired,
  services: PropTypes.array.isRequired,
  setHasError: PropTypes.func.isRequired,
};

export default ContractItem;
